import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import cx from "classnames";
import { useButtonClasses } from "../components/ThemeContext.js";
import { useAnimationProps } from "../components/Animation.js";
export const getClassName = (ownProps, animationProps, classes) => cx(classes.btn, classes[ownProps.size], classes[ownProps.color], ownProps.className, ownProps.block === true && classes.block, `block-${ownProps.block}` in classes && classes[`block-${ownProps.block}`], ownProps.disabled && classes.disabled, ownProps.isLoading && classes.disabled, ownProps.active && classes.active, animationProps.clicked && classes.clicked);
const getContainerClassName = (ownProps, animationProps, classes) => cx(classes.container, ownProps.className, ownProps.disabled && classes.disabled, ownProps.active && classes.active, animationProps.clicked && classes.clicked);
const mergeCallbacks = function () {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _forEachInstanceProperty(callbacks).call(callbacks, callback => {
      if (typeof callback === 'function') {
        callback(...args);
      }
    });
  };
};
const disabledProps = {
  tabIndex: '-1',
  role: 'button',
  'aria-disabled': 'true'
};
const disabledClickHandler = evt => {
  evt.preventDefault();
};
const handleLinkProps = (ownProps, animationProps, isContainer, linkStyles) => {
  const {
    active,
    block,
    classes,
    className,
    color,
    disabled,
    href,
    iconName,
    isLoading,
    labelDirection,
    onClick: ownOnClick,
    size,
    to,
    ...passThroughProps
  } = ownProps;
  const isDisabled = disabled || isLoading || !href && !to;
  const additionalProps = isDisabled ? disabledProps : {
    href,
    to
  };
  const onClick = isDisabled ? disabledClickHandler : mergeCallbacks(animationProps.onClick, ownOnClick);
  const classNameFunc = isContainer ? getContainerClassName : getClassName;
  return {
    ...passThroughProps,
    ...additionalProps,
    onClick,
    className: classNameFunc(ownProps, animationProps, linkStyles)
  };
};
const handleButtonProps = (ownProps, animationProps, isContainer, buttonStyles) => {
  const {
    active,
    block,
    classes,
    className,
    color,
    disabled,
    iconName,
    isLoading,
    labelDirection,
    onClick: ownOnClick,
    size,
    type,
    ...passThroughProps
  } = ownProps;
  const isDisabled = isLoading || disabled;
  const classNameFunc = isContainer ? getContainerClassName : getClassName;
  return {
    ...passThroughProps,
    'aria-disabled': isDisabled,
    className: classNameFunc(ownProps, animationProps, buttonStyles),
    disabled: isDisabled,
    onClick: mergeCallbacks(animationProps.onClick, ownOnClick),
    type
  };
};
export const useButtonProps = (ownProps, isContainer) => {
  const animationProps = useAnimationProps();
  const classes = useButtonClasses(ownProps.classes);
  return handleButtonProps(ownProps, animationProps, isContainer, classes);
};
export const useLinkProps = (ownProps, isContainer) => {
  const animationProps = useAnimationProps();
  const classes = useButtonClasses(ownProps.classes);
  return handleLinkProps(ownProps, animationProps, isContainer, classes);
};
export const limitPropUsageToTertiaryButtons = propType => function (props, propName) {
  if (props[propName] && props.color !== 'tertiary') {
    return new Error(`The ${propName} prop is only available if the \`color\` prop is set to "tertiary".`);
  }
  for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    rest[_key3 - 2] = arguments[_key3];
  }
  return propType(props, propName, ...rest);
};